<div *ngIf="unsupportedBrowser" class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>You are on an unsupported browser.</strong> Please use Edge, Chrome, or Safari for a better user experience.
   
  </div>
<router-outlet></router-outlet>
